export enum TenaSampleType {
    TridionHosted = 0,
    IFrame = 1,
    External = 2
}
